export default __webpack_public_path__ + "static/media/speakers__james-thomson.80af667b.jpg";